import nodeApi from '../utils/nodeApiClient';
import UnifiedConfig from '../config/unified';

const quotationsApi = {
  list: (params) => nodeApi.get('/quotations', { params }),
  getById: (id) => nodeApi.get(`/quotations/${id}`),
  create: (data) => nodeApi.post('/quotations', data),
  update: (id, data) => nodeApi.put(`/quotations/${id}`, data),
  remove: (id) => nodeApi.delete(`/quotations/${id}`),

  getDropdowns: () => nodeApi.get('/quotations/dropdowns'),
  getAccepted: (contactId) => nodeApi.get('/quotations/accepted', { params: contactId ? { contact_id: contactId } : {} }),
  getCompaniesWithAccepted: () => nodeApi.get('/quotations/companies-with-accepted'),

  getDetails: (id) => nodeApi.get(`/quotations/${id}/details`),
  getServices: (id, edit) => nodeApi.get(`/quotations/${id}/services`, { params: edit ? { edit: 'true' } : {} }),
  getAllServices: (id) => nodeApi.get(`/quotations/${id}/services/all`),
  updateServiceDescriptions: (id, services) => nodeApi.put(`/quotations/${id}/services/descriptions`, { services }),
  getReferences: (id) => nodeApi.get(`/quotations/${id}/references`),
  confirm: (id, status) => nodeApi.post(`/quotations/${id}/confirm`, { status }),

  send: (id, data) => nodeApi.post(`/quotations/${id}/send`, data, { timeout: 60000 }),
  getPdfDownloadUrl: async (id, billCompanyId) => {
    const base = await UnifiedConfig.getNodeApiBaseUrl();
    return `${base}/quotations/${id}/pdf${billCompanyId ? `?bill_company_id=${billCompanyId}` : ''}`;
  }
};

export default quotationsApi;
